function buildViewportKey(pageId) {
    return 'blocksuite:' + pageId + ':edgelessViewport';
}
export const saveViewportToSessionCommand = (ctx, next) => {
    const pageId = ctx.host?.page.id;
    if (!pageId)
        return;
    const { viewport } = ctx;
    sessionStorage.setItem(buildViewportKey(pageId), JSON.stringify(viewport));
    return next();
};
export const getViewportFromSessionCommand = (ctx, next) => {
    const pageId = ctx.host?.page.id;
    if (!pageId)
        return;
    const viewportStr = sessionStorage.getItem(buildViewportKey(pageId));
    const storedViewport = viewportStr
        ? JSON.parse(viewportStr)
        : null;
    return next({ storedViewport });
};
//# sourceMappingURL=session.js.map